import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Challengestock() {
  return (
    <section className="challenge_stock p-100 text_white bg_stock text_stock">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center resp_order"
          >
            <div className="challenge_stock text-center">
              <StaticImage
                src="../../../images/case-studies/stock/challenges.webp"
                alt="TekRevol"
                className=""
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={655}
                height={520}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <h1>
              CHALLENGES <span> & SOLUTIONS</span>
            </h1>
            <p>
              A seamless network where businesses could have a better look at
              insights and analytics and manage the complexity of it all needed
              to be added to the broader ecosystem.
            </p>
            <p>
              Businesses were gradually reflecting on this matter, and our
              client wanted a fully-fledged platform where companies could visit
              their distinctive portal to see and manage their products,
              reflecting on how to reach consumers.
            </p>
            <p>
              We designed an API that connects businesses with Stock n Ship –
              each store is integrated into our network, where inventory and
              orders can be tracked comfortably. For the admin side, a separate
              portal is included.
            </p>
            <p>
              Also, our set of web application interfaces (portals) is built for
              stores and suppliers separately.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Challengestock;
